<ion-header class="extendido">
  <ion-buttons left>
    <ion-button (click)="closeModal()">
      <ion-back-button icon="arrow-back-outline" text="" defaultHref="login"></ion-back-button>
    </ion-button>
    <ion-title>{{'Cadastro' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div class="gradient-extendido grad-height"></div>

  <ion-card class="gradient-extendido-recuo grad-recuo margin-card">
    <ion-card-content>

      <form class="sample-form validations-form" [formGroup]="validations_form"
        (ngSubmit)="onSubmit(validations_form.value)">

        <div class="dangerEmail">
          <i class="fa-solid fa-church icon-enve"></i>
          <ion-label class="custom-text" position="stacked">{{'Código da Igreja' | translate}}</ion-label>
        </div>

        <ion-row>
          <ion-col size="12">
            <ion-item class="custom-input">
              <ion-input type="text" class="custom" (ionChange)="mudarCodigo();" formControlName="codigo" placeholder="{{'Digite seu código' | translate}}"></ion-input>
            </ion-item>
          </ion-col>
        </ion-row>

        <div class="validation-errors">
          <ng-container *ngFor="let validation of validation_messages.codigo">
            <div class="error-message" style="padding: 0px 0px 10px 20px;"
              *ngIf="validations_form.get('codigo')?.hasError(validation.type) && (validations_form.get('codigo')?.dirty || validations_form.get('codigo')?.touched)">
              {{ validation.message }}
            </div>
          </ng-container>
        </div>

        <div style="text-align: center;">
          <p class="info"> {{'Informe o código fornecido por sua igreja' | translate}}</p>
        </div>

        <div [hidden]="!error" class="validation-errors" style="padding: 0px 0px 10px 20px;">
          <div class="error-message">
            {{'Código inválido' | translate}}
          </div>
        </div>

        <div class="down">
          <ion-button expand="block" color="primary" type="submit" [disabled]="!validations_form.valid"
            class="btn-prover enviar">
            {{'Continuar' | translate}}
            <ion-icon slot="end" name="arrow-forward-outline"></ion-icon>
          </ion-button>
        </div>

      </form>
    </ion-card-content>
  </ion-card>
</ion-content>